import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { PickerService } from '../../services/picker/picker.service';
import { environment } from '../../../environments/environment';
import { Lottery, Offer } from '../../models/offer.model';
import { LottosService } from '../../services/lottos/lottos.service';
import { WindorefService } from '../../services/window/windoref.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-discount-product',
  templateUrl: './discount-product.component.html',
  styleUrls: ['./discount-product.component.scss']
})
export class DiscountProductComponent implements OnInit, AfterContentInit {
  public pickerForm: FormGroup;
  private lottery: Lottery = environment.lottery;
  private offer: Offer = this.lottery.hasOwnProperty('offer') ? this.lottery.offer : null;
  public base: number;
  public multiplier: number;
  public upLogIn: boolean = false;
  public enableLogin: boolean = true;
  public picksCount: number = 0;
  public picksFrom: number;
  public picksTo: number;
  private extraPicksCount: number = 0;
  public extraPicksAux: number = 0;
  public extraPicksFrom: number;
  public extraPicksTo: number;
  public totalTicketPrice: number;
  public ticketPrice: number;
  public currency: string;
  public params: string;
  private repeatedPick: any[] = [];
  private repeatedExtra: any[] = [];
  public lottoName: string;
  public prodId: number;
  public sys: string;
  public lotName: string;
  public baseUrl: string = 'https://d3tmfelegj51yl.cloudfront.net/lotto-logos/';
  public subs: Subscription;

  @Input() system: string;
  constructor(
    protected _lottosService: LottosService,
    protected _window: WindorefService,
    protected _formBuilder: FormBuilder,
    protected _pickerService: PickerService
  ) {
    this.params = this._window.getNativeWindow().location.search;
  }

  ngOnInit(): void {
    this.getOfferData();
    this.bringLottos();
    this.setLottoName();
  }

  ngAfterContentInit(): void {
    this.buildPickerForm();
    this.setBasePicks();
  }

  setLottoName(): void {
    this.subs = this._lottosService.lottoObservable$.subscribe((lottoObj) => {
      this.lottoName = lottoObj['name']?.replace(/\s+/g, '').toLowerCase();
      this.prodId = lottoObj['id'];
      this.sys = lottoObj['system'];
      this.lotName = lottoObj['name']?.replace(/\s+/g, '').toLowerCase();
    });
  }

  getOfferData(): void {
    if (this.offer !== null) {
      this.base = this.offer.base;
      this.multiplier = this.offer.multiplier;
      this.picksCount = this.offer.picks.count;
      this.picksFrom = this.offer.picks.from;
      this.picksTo = this.offer.picks.to;
      this.extraPicksCount = this.offer.extra_picks.count;
      this.extraPicksFrom = this.offer.extra_picks.from;
      this.extraPicksTo = this.offer.extra_picks.to;
    } else {
      console.error('empty offer');
    }
  }

  getBaseRandomArbitrary(): number {
    return Number((Math.random() * (this.picksTo - this.picksFrom) + this.picksFrom).toFixed(0));
  }

  getExtraRandomArbitrary(): number {
    return Number((Math.random() * (this.extraPicksTo - this.extraPicksFrom) + this.extraPicksFrom).toFixed(0));
  }

  buildPickerForm(): void {
    this.pickerForm = this._formBuilder.group({
      basePick: this._formBuilder.array([])
    });
  }

  get basePick(): FormArray {
    return this.pickerForm.get('basePick') as FormArray;
  }

  addPickBox(pos: number = 0, max: number): void {
    (this.basePick.at(pos) as FormArray).push(this._formBuilder.control('', [Validators.required, Validators.max(max)]));
  }

  generatePick(picker: number = 0, pick: number = 0, isExtraPick = false): number {
    let random: number;
    if (isExtraPick === false) {
      random = this.getBaseRandomArbitrary();
      while (this.repeatedPick[picker].includes(random)) {
        random = this.getBaseRandomArbitrary();
      }
      this.repeatedPick[picker].push(random);
    } else {
      random = this.getExtraRandomArbitrary();
      while (this.repeatedExtra[picker].includes(random)) {
        random = this.getExtraRandomArbitrary();
      }
      this.repeatedExtra[picker].push(random);
    }
    return random;
  }

  validateControl(picker: number, pick: number) {
    let currentValue = this.basePick.controls[picker]['controls'][pick].value;
    if (pick < this.picksCount && (currentValue < this.picksFrom || currentValue > this.picksTo)) {
      this.basePick.controls[picker]['controls'][pick].setValue('');
      this.basePick.controls[picker]['controls'][pick].status = 'INVALID';
      this.enableLogin = false;
      return false;
    } else if (
      this.extraPicksCount > 0 &&
      this.basePick.controls[picker]['controls'][5].value === currentValue &&
      (currentValue < this.extraPicksFrom || currentValue > this.extraPicksTo)
    ) {
      this.basePick.controls[picker]['controls'][pick].setValue('');
      this.enableLogin = false;
      return false;
    } else {
      this.basePick.controls[picker]['controls'][pick].status == 'VALID';
      this.updateControlArray(picker, pick, currentValue);
      this.enableLogin = true;
    }
  }

  userInputControl(picker: number, pick: number): void {
    this.basePick.controls[picker]['controls'][pick].status === 'VALID';
    this.enableLogin = true;

    let currentValue = this.basePick.controls[picker]['controls'][pick].value;
    let pickerArray: any[] = pick < this.picksCount ? this.repeatedPick[picker] : this.repeatedExtra[picker];
    let pickAux: number = pick < this.picksCount ? pick : pick - this.picksCount;

    if (
      (this.extraPicksCount > 0 && pickerArray.includes(currentValue) && pickerArray[pickAux] !== currentValue) ||
      typeof currentValue == 'undefined' ||
      currentValue < 1
    ) {
      this.basePick.controls[picker]['controls'][pick].status = 'INVALID';
      this.enableLogin = false;
    } else if ((this.extraPicksCount === 0 && pickerArray.includes(currentValue)) || typeof currentValue === 'undefined' || currentValue < 1) {
    } else if (this.basePick.controls[picker]['controls'][pick].status === 'VALID') {
      this.updateControlArray(picker, pick, currentValue);
      this.enableLogin = true;
    }
  }

  updateControlArray(picker: number, pick: number, value: number): void {
    if (pick < this.picksCount) {
      this.repeatedPick[picker][pick] = value;
    } else {
      pick = pick - this.picksCount;
      this.repeatedExtra[picker][pick] = value;
    }
  }

  initializeRepeatedControl(): void {
    for (let index = 0; index < this.multiplier; index++) {
      this.repeatedPick.push([]);
      this.repeatedExtra.push([]);
    }
  }

  createPicker(): void {
    this.basePick.push(this._formBuilder.array([]));
  }

  setBasePicks(): void {
    this.initializeRepeatedControl();
    let pickerNumber: number = 0;
    /* #Picker */
    for (let p of [].constructor(this.multiplier)) {
      this.createPicker();
      this.createPickBoxes(pickerNumber);
      this.quickPick(pickerNumber);
      pickerNumber = pickerNumber + 1;
    }
  }

  quickPick(picker: number): void {
    let pickPosition: number = 0;
    let arrPicks: number[] = [];
    let arrExtraPicks: number[] = [];
    this.restartRepeatedPicks(picker);
    /* Normal picks */
    for (let p of [].constructor(this.picksCount)) {
      let random = this.generatePick(picker, pickPosition);
      arrPicks.push(random);
      pickPosition = pickPosition + 1;
    }
    /* Extra picks */
    for (let p of [].constructor(this.extraPicksCount)) {
      let random = this.generatePick(picker, pickPosition, true);
      arrExtraPicks.push(random);
      pickPosition = pickPosition + 1;
    }
    let sortedPicks: number[] = arrPicks.sort((a, b) => a - b);
    let sortedExtraPicks: number[] = arrExtraPicks.sort((a, b) => a - b);
    this.postulatePicks(picker, sortedPicks, sortedExtraPicks);
  }

  private restartRepeatedPicks(picker: number): void {
    this.repeatedPick[picker] = [];
    this.repeatedExtra[picker] = [];
  }

  private postulatePicks(picker: number, arrPicks: number[], arrExtraPicks: number[]): void {
    let position: number = 0;
    arrPicks.map((value) => {
      this.basePick.controls[picker]['controls'][position].setValue(value);
      position = position + 1;
    });
    arrExtraPicks.map((value) => {
      this.basePick.controls[picker]['controls'][position].setValue(value);
      position = position + 1;
    });
  }

  private createPickBoxes(picker) {
    /* Picks */
    for (let p of [].constructor(this.picksCount)) {
      this.addPickBox(picker, this.picksTo);
    }
    /* Extra pick */
    for (let p of [].constructor(this.extraPicksCount)) {
      this.addPickBox(picker, this.extraPicksTo);
    }
  }

  private bringLottos(): void {
    this._lottosService.lottoPrice$.subscribe((data) => {
      this.ticketPrice = data.price;
      this.currency = data.currency;
      this.totalTicketPrice = data.price * this.base;
    });
  }

  showLogin($event): void {
    this._pickerService.setUserPicks(this.pickerForm.value.basePick);
    this.upLogIn = true;
    //this._window.getNativeWindow().document.body.scrollTop = 720;
    //this._window.getNativeWindow().document.documentElement.scrollTop = 720;
  }

  hideLogin(): void {
    this.upLogIn = false;
  }
}
